// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3E8qG","vLegacy":"SelectSecondary_vLegacy__26ICL","error":"SelectSecondary_error__3rAJr","disabled":"SelectSecondary_disabled__3F5f2"};